// Zentraler, harter Logout inkl. Hinweis & Redirect
import { Modal } from "antd";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { clearAllAuthParams } from "./tokenStorage";
import "./logout.css";

const BRAND = "#153e8c";
const AUTH0_LOGIN_URL = "https://login.muessig.app/";

// Guard, damit es nur einmal feuert
let isLoggingOut = false;

function buildLoginUrl(returnTo?: string): string {
    try {
        const url = new URL(AUTH0_LOGIN_URL);
        if (returnTo) url.searchParams.set("returnTo", returnTo);
        return url.toString();
    } catch {
        return AUTH0_LOGIN_URL;
    }
}

export function forceLogout(
    reason = "Login abgelaufen. Bitte melde dich erneut an."
) {
    if (isLoggingOut) return;
    isLoggingOut = true;

    try { clearAllAuthParams(); } catch {}

    const returnTo = `${window.location.origin}${window.location.pathname}`;

    // Nutzen Modal.confirm statt warning => volle Kontrolle über Icon & Buttons
    try {
        Modal.destroyAll();
        Modal.confirm({
            className: "mu-logout-modal",
            icon: <ExclamationCircleFilled style={{ color: BRAND, fontSize: 24 }} />,
        title: "Sitzung beendet",
            content: reason,
            okText: "Zum Login",
            cancelButtonProps: { style: { display: "none" } }, // keine Cancel-Taste
        closable: false,
            maskClosable: false,
            keyboard: false,
            centered: true,
            okButtonProps: {
            style: { backgroundColor: BRAND, borderColor: BRAND },
        },
        onOk: () => {
            window.location.href = buildLoginUrl(returnTo);
        },
            afterClose: () => {
            // Fallback, falls User Modal schließt (sollte dank closable=false nicht passieren)
            if (isLoggingOut) window.location.href = buildLoginUrl(returnTo);
        },
    });
    } catch {
        alert(reason);
        window.location.href = buildLoginUrl(returnTo);
    }
}